module.exports = __webpack_public_path__ + "img/online.49e28f4f.svg";